$(function(){
	let $popup = $('.js-popup');
	let $popupOpenBtn = $('.js-popup-link');
	let $popupCloseBtn = $('.js-popup-close');
	let lastOpenedPopup = null;
	let scrollPosition;

	if (location.hash !== '') {
		$(`.js-popup[data-block='${location.hash.substr(1)}']`).addClass('is-show');
		scrollPosition = $(window).scrollTop();
	}

	$popupOpenBtn.click(function(e){
		e.preventDefault();
		let $this = $(this);
		let target = $this.attr('data-link');
		$popup.removeClass('is-show');
		$('.js-popup[data-block="'+target+'"]').addClass('is-show');
		scrollPosition = $(window).scrollTop();
		return false
	});

	$popupCloseBtn.click(function(){
		let $this = $(this);
		let $popup = $this.closest('.js-popup');
		$popup.removeClass('is-show');
		$('.js-copy').fadeOut();
		if (scrollPosition !== "undefined") {
			$(window).scrollTop(scrollPosition);
			scrollPosition = undefined;
		}
	});

  let popupContent = '.js-ajax-content';

  $(document).on('click', '.js-popup-ajax',function(e) {
  	e.preventDefault();

    let href = $(this).attr('data-href');
    let target = $(this).attr('data-target');

    openPopup(target, href);

  });

  function openPopup(target, href) {
  	const $elem = $('.js-popup[data-block="'+target+'"]');
  	$popup.removeClass('is-show');
	$elem.addClass('is-show');

	if (target !== 'media') {
		location.hash = target;
	}
	scrollPosition = $(window).scrollTop();

	if (href) {
      	history.pushState({}, '', href);
			$('.js-popup[data-block="'+target+'"]').find('.js-ajax-content').empty();
			getAjaxProductCard(href,$('.js-popup[data-block="'+target+'"]'));
			lastOpenedPopup = 'href';
		}

  }

  window.openPopup = openPopup;

  function getAjaxProductCard(href,target){
    $.ajax({
      type: "get",
      url: href,
      success: data => {
	  	$('.js-popup[data-block="'+target+'"]').addClass('is-show');

        setTimeout ( () => {
			$(popupContent)
				.html(data)
				.hide()
				.fadeIn();
        }, 400);
      },
      error: (xhr, ajaxOptions, thrownError) => {
        console.log(xhr, ajaxOptions, thrownError);
      }
    });
    $('.js-popup-close').on('click', function(){
      $('.js-popup-content').removeClass('is-show');
      	if (lastOpenedPopup === 'href') {
			history.back();
			let scrollPositionLast = $(window).scrollTop();
			lastOpenedPopup = null;
		}
    })
  }

});
